/**
 * CARS Act arrival disclosure.
 *
 * inventory_date arrives as "YYYY-MM-DD" from both sources:
 *   - VDP: CarDetailsSerializer (DRF DateField)
 *   - SRP: CarAlgolia.payload (date.isoformat() in assemble_algolia)
 *
 * The date is parsed as a LOCAL calendar date. new Date("YYYY-MM-DD")
 * would parse as UTC midnight and display the previous day in Pacific
 * time.
 *
 * Returns a display string ("October 30, 2026") when the date is after
 * today, otherwise null (vehicle already on the lot, or no date).
 */
export function expectedArrival(value) {
  if (!value || typeof value !== "string") return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (!m) return null;
  const arrival = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  if (isNaN(arrival.getTime())) return null;
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  if (arrival <= today) return null;
  return arrival.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}
